import React, { FC } from 'react';
import styles from './styles.module.css';

type Props = {
  value: string;
  onValueChange: (arg: string) => void;
  edit: boolean;
  Icon: FC;
};

export const InventoryItemData: FC<Props> = ({ value, onValueChange, edit, Icon }: Props) => {
  return (
    <div className={styles.roundedButton}>
      <Icon />
      {edit ? (
        <input type='number' value={value} onChange={(ev) => onValueChange(ev.target.value)} />
      ) : (
        <div>{value}</div>
      )}
    </div>
  );
};
